import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '../../../../services/user.service';
import { RequestsServices } from '../../../../services/requests.service';
import { OfferService } from '../../../../services/offer.service';


@Component({
  selector: 'offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss']
})
export class OfferCardComponent implements OnInit {

  @Input() offer;
  @Output() onSaveOffer = new EventEmitter();

  initialState: string;
  confirmation = false;
  loading = false;
  offer_attributes;

  constructor(
    private userService: UserService,
    private request: RequestsServices,
    private offerService: OfferService
  ) {}

  ngOnInit() {
    this.initialState = this.offer.state;
    this.offer_attributes = this.offerService.getFullOffer(this.offer.application_slug);
  }

  isActive() {
    return this.offer.state === 'completed' || this.offer.state === 'waitingApproval';
  }

  onChangeOfferState() {
    this.offer.state = this.isActive() ? 'blocked' : 'waitingApproval';
    this.confirmation = this.offer.state !== this.initialState;
  }

  confirmStateChange() {
    this.loading = true;

    this.saveEstablishment(this.offer).then(establishment => {
      this.initialState = this.offer.state;
      this.confirmation = false;
      this.loading = false;
      this.onSaveOffer.emit(establishment.applications_offer);
    });
  }

  saveEstablishment(offer) {
    const establishment = this.userService.getLoggedAccount();

    const establishmentData = {};
    const { applications_offer, id } = establishment;

    if (offer.application_slug === 'allya') {
      establishmentData['offer'] = offer;
    } else {
      establishmentData['applications_offer'] = applications_offer
        ? applications_offer.map(el => el.application_slug === offer.application_slug ? offer : el)
        : [];
    }

    return this.request.patch('establishments', establishmentData, '', `/${id}`);
  }
}
